/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EchoGenerateTTS } from '../models/EchoGenerateTTS';
import type { PaginatedTTSProviderLanguageListList } from '../models/PaginatedTTSProviderLanguageListList';
import type { PaginatedTTSProviderLanguageWriteSerializerWithReprList } from '../models/PaginatedTTSProviderLanguageWriteSerializerWithReprList';
import type { PaginatedTTSProviderReadList } from '../models/PaginatedTTSProviderReadList';
import type { PaginatedTTSProviderWriteSerializerWithReprList } from '../models/PaginatedTTSProviderWriteSerializerWithReprList';
import type { PatchedTTSProviderLanguageWriteSerializerWithRepr } from '../models/PatchedTTSProviderLanguageWriteSerializerWithRepr';
import type { PatchedTTSProviderWriteSerializerWithRepr } from '../models/PatchedTTSProviderWriteSerializerWithRepr';
import type { TTSProviderLanguageRead } from '../models/TTSProviderLanguageRead';
import type { TTSProviderLanguageWriteSerializerWithRepr } from '../models/TTSProviderLanguageWriteSerializerWithRepr';
import type { TTSProviderRead } from '../models/TTSProviderRead';
import type { TTSProviderWriteSerializerWithRepr } from '../models/TTSProviderWriteSerializerWithRepr';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TtsService {
    /**
     * @returns PaginatedTTSProviderReadList
     * @throws ApiError
     */
    public static ttsList({
        displayName,
        excludeFields,
        fields,
        languages,
        limit,
        name,
        offset,
        ordering,
        readDepth,
        search,
        ssmlTags,
    }: {
        displayName?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        languages?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        ssmlTags?: Array<string>,
    }): CancelablePromise<PaginatedTTSProviderReadList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tts/',
            query: {
                'display_name': displayName,
                'exclude-fields': excludeFields,
                'fields': fields,
                'languages': languages,
                'limit': limit,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
                'ssml_tags': ssmlTags,
            },
        });
    }
    /**
     * @returns TTSProviderWriteSerializerWithRepr
     * @throws ApiError
     */
    public static ttsCreate({
        requestBody,
    }: {
        requestBody: TTSProviderWriteSerializerWithRepr,
    }): CancelablePromise<TTSProviderWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tts/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedTTSProviderWriteSerializerWithReprList
     * @throws ApiError
     */
    public static ttsProviderBulkUpdate({
        requestBody,
        displayName,
        excludeFields,
        fields,
        languages,
        limit,
        name,
        offset,
        ordering,
        readDepth,
        search,
        ssmlTags,
    }: {
        requestBody: Array<TTSProviderWriteSerializerWithRepr>,
        displayName?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        languages?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        ssmlTags?: Array<string>,
    }): CancelablePromise<PaginatedTTSProviderWriteSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/tts/',
            query: {
                'display_name': displayName,
                'exclude-fields': excludeFields,
                'fields': fields,
                'languages': languages,
                'limit': limit,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
                'ssml_tags': ssmlTags,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedTTSProviderWriteSerializerWithReprList
     * @throws ApiError
     */
    public static ttsProviderBulkPartialUpdate({
        requestBody,
        displayName,
        excludeFields,
        fields,
        languages,
        limit,
        name,
        offset,
        ordering,
        readDepth,
        search,
        ssmlTags,
    }: {
        requestBody: Array<TTSProviderWriteSerializerWithRepr>,
        displayName?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        languages?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        ssmlTags?: Array<string>,
    }): CancelablePromise<PaginatedTTSProviderWriteSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/tts/',
            query: {
                'display_name': displayName,
                'exclude-fields': excludeFields,
                'fields': fields,
                'languages': languages,
                'limit': limit,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
                'ssml_tags': ssmlTags,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static ttsProviderBulkDestroy({
        id,
    }: {
        id?: Array<number>,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/tts/',
            query: {
                'id': id,
            },
        });
    }
    /**
     * @returns TTSProviderRead
     * @throws ApiError
     */
    public static ttsRetrieve({
        id,
        displayName,
        excludeFields,
        fields,
        languages,
        name,
        readDepth,
        ssmlTags,
    }: {
        /**
         * A unique integer value identifying this tts provider.
         */
        id: number,
        displayName?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        languages?: Array<string>,
        name?: Array<string>,
        readDepth?: number,
        ssmlTags?: Array<string>,
    }): CancelablePromise<TTSProviderRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tts/{id}/',
            path: {
                'id': id,
            },
            query: {
                'display_name': displayName,
                'exclude-fields': excludeFields,
                'fields': fields,
                'languages': languages,
                'name': name,
                'read_depth': readDepth,
                'ssml_tags': ssmlTags,
            },
        });
    }
    /**
     * @returns TTSProviderWriteSerializerWithRepr
     * @throws ApiError
     */
    public static ttsUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this tts provider.
         */
        id: number,
        requestBody: TTSProviderWriteSerializerWithRepr,
    }): CancelablePromise<TTSProviderWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/tts/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns TTSProviderWriteSerializerWithRepr
     * @throws ApiError
     */
    public static ttsPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this tts provider.
         */
        id: number,
        requestBody?: PatchedTTSProviderWriteSerializerWithRepr,
    }): CancelablePromise<TTSProviderWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/tts/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static ttsDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this tts provider.
         */
        id: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/tts/{id}/',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns PaginatedTTSProviderLanguageListList
     * @throws ApiError
     */
    public static ttsModelsList({
        providerPk,
        agent,
        excludeFields,
        fields,
        language,
        limit,
        offset,
        ordering,
        provider,
        readDepth,
        search,
        tonalityOptions,
    }: {
        providerPk: number,
        agent?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        language?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        provider?: Array<string>,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        tonalityOptions?: Array<string>,
    }): CancelablePromise<PaginatedTTSProviderLanguageListList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tts/{provider_pk}/models/',
            path: {
                'provider_pk': providerPk,
            },
            query: {
                'agent': agent,
                'exclude-fields': excludeFields,
                'fields': fields,
                'language': language,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'provider': provider,
                'read_depth': readDepth,
                'search': search,
                'tonality_options': tonalityOptions,
            },
        });
    }
    /**
     * @returns TTSProviderLanguageWriteSerializerWithRepr
     * @throws ApiError
     */
    public static ttsModelsCreate({
        providerPk,
        requestBody,
    }: {
        providerPk: number,
        requestBody: TTSProviderLanguageWriteSerializerWithRepr,
    }): CancelablePromise<TTSProviderLanguageWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tts/{provider_pk}/models/',
            path: {
                'provider_pk': providerPk,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedTTSProviderLanguageWriteSerializerWithReprList
     * @throws ApiError
     */
    public static ttsProviderLanguageBulkUpdate({
        providerPk,
        requestBody,
        agent,
        excludeFields,
        fields,
        language,
        limit,
        offset,
        ordering,
        provider,
        readDepth,
        search,
        tonalityOptions,
    }: {
        providerPk: number,
        requestBody: Array<TTSProviderLanguageWriteSerializerWithRepr>,
        agent?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        language?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        provider?: Array<string>,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        tonalityOptions?: Array<string>,
    }): CancelablePromise<PaginatedTTSProviderLanguageWriteSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/tts/{provider_pk}/models/',
            path: {
                'provider_pk': providerPk,
            },
            query: {
                'agent': agent,
                'exclude-fields': excludeFields,
                'fields': fields,
                'language': language,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'provider': provider,
                'read_depth': readDepth,
                'search': search,
                'tonality_options': tonalityOptions,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedTTSProviderLanguageWriteSerializerWithReprList
     * @throws ApiError
     */
    public static ttsProviderLanguageBulkPartialUpdate({
        providerPk,
        requestBody,
        agent,
        excludeFields,
        fields,
        language,
        limit,
        offset,
        ordering,
        provider,
        readDepth,
        search,
        tonalityOptions,
    }: {
        providerPk: number,
        requestBody: Array<TTSProviderLanguageWriteSerializerWithRepr>,
        agent?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        language?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        provider?: Array<string>,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        tonalityOptions?: Array<string>,
    }): CancelablePromise<PaginatedTTSProviderLanguageWriteSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/tts/{provider_pk}/models/',
            path: {
                'provider_pk': providerPk,
            },
            query: {
                'agent': agent,
                'exclude-fields': excludeFields,
                'fields': fields,
                'language': language,
                'limit': limit,
                'offset': offset,
                'ordering': ordering,
                'provider': provider,
                'read_depth': readDepth,
                'search': search,
                'tonality_options': tonalityOptions,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static ttsProviderLanguageBulkDestroy({
        providerPk,
        id,
    }: {
        providerPk: number,
        id?: Array<number>,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/tts/{provider_pk}/models/',
            path: {
                'provider_pk': providerPk,
            },
            query: {
                'id': id,
            },
        });
    }
    /**
     * @returns TTSProviderLanguageRead
     * @throws ApiError
     */
    public static ttsModelsRetrieve({
        id,
        providerPk,
        agent,
        excludeFields,
        fields,
        language,
        provider,
        readDepth,
        tonalityOptions,
    }: {
        /**
         * A unique integer value identifying this tts provider language.
         */
        id: number,
        providerPk: number,
        agent?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        language?: Array<string>,
        provider?: Array<string>,
        readDepth?: number,
        tonalityOptions?: Array<string>,
    }): CancelablePromise<TTSProviderLanguageRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tts/{provider_pk}/models/{id}/',
            path: {
                'id': id,
                'provider_pk': providerPk,
            },
            query: {
                'agent': agent,
                'exclude-fields': excludeFields,
                'fields': fields,
                'language': language,
                'provider': provider,
                'read_depth': readDepth,
                'tonality_options': tonalityOptions,
            },
        });
    }
    /**
     * @returns TTSProviderLanguageWriteSerializerWithRepr
     * @throws ApiError
     */
    public static ttsModelsUpdate({
        id,
        providerPk,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this tts provider language.
         */
        id: number,
        providerPk: number,
        requestBody: TTSProviderLanguageWriteSerializerWithRepr,
    }): CancelablePromise<TTSProviderLanguageWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/tts/{provider_pk}/models/{id}/',
            path: {
                'id': id,
                'provider_pk': providerPk,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns TTSProviderLanguageWriteSerializerWithRepr
     * @throws ApiError
     */
    public static ttsModelsPartialUpdate({
        id,
        providerPk,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this tts provider language.
         */
        id: number,
        providerPk: number,
        requestBody?: PatchedTTSProviderLanguageWriteSerializerWithRepr,
    }): CancelablePromise<TTSProviderLanguageWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/tts/{provider_pk}/models/{id}/',
            path: {
                'id': id,
                'provider_pk': providerPk,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static ttsModelsDestroy({
        id,
        providerPk,
    }: {
        /**
         * A unique integer value identifying this tts provider language.
         */
        id: number,
        providerPk: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/tts/{provider_pk}/models/{id}/',
            path: {
                'id': id,
                'provider_pk': providerPk,
            },
        });
    }
    /**
     * @returns TTSProviderLanguageRead
     * @throws ApiError
     */
    public static ttsModelsGenerateCreate({
        id,
        providerPk,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this tts provider language.
         */
        id: number,
        providerPk: number,
        requestBody: EchoGenerateTTS,
    }): CancelablePromise<TTSProviderLanguageRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tts/{provider_pk}/models/{id}/generate/',
            path: {
                'id': id,
                'provider_pk': providerPk,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
